import React from 'react'
const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <div className='video'>
    <video autoPlay muted loop>
      <source src={videoSrcURL} type="video/mp4" />
    </video>
  </div>
)
export default Video
